import React from "react";
import { Outlet } from "react-router-dom";
import Main from "../components/admin/layout/Main";
import LoadingOverlayWrapper from "react-loading-overlay-ts";
import { ToastContainer } from "react-toastify";
import { useSelector } from "react-redux";
import { ConfigProvider } from "antd";

const TheLayoutAdmin = () => {
  const statusLoading = useSelector((state) => state.globalLoading.status);
  return (
    <ConfigProvider
      theme={{
        token: {
          borderRadius: 4,
        },
        components: {
          Select: { borderRadius: 4 },
          Button: { borderRadius: 4 },
          Input: { borderRadius: 4 },
          Card: { borderRadius: 4 },
        },
      }}
    >
      <LoadingOverlayWrapper active={statusLoading} spinner>
        <div className="admin-layout">
          <Main>
            <Outlet />
          </Main>
        </div>
        <ToastContainer />
      </LoadingOverlayWrapper>
    </ConfigProvider>
  );
};

export default TheLayoutAdmin;
